import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import SweetAlert from 'react-bootstrap-sweetalert';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import { Button, Card, CardBody, CardTitle, Col, FormGroup, Label } from 'reactstrap';
import { updateEntryStrategy } from '../../store/actions';
import EntryStrategyAreaList from '../Lists/EntryStrategyAreaList';

class UpdateEntryStrategyForm extends Component {
  constructor(props) {
    super(props);
    let load = true;

    // Si no viene la estrategia del listado, redirigimos
    if (!this.props.entryStrategy) {
      this.props.history.push('/entry-strategies');
      load = false;
    }

    const entryStrategy = this.props.entryStrategy ? this.props.entryStrategy.entryStrategy : null;

    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      entryStrategy: entryStrategy,
      originalName: entryStrategy ? entryStrategy.name : '', // Guardamos el nombre inicial
      currentName: entryStrategy ? entryStrategy.name : '', // Nombre en tiempo real
      popup: false,
      pop_msg: '',
      load: load,
      alertType: '',
    };

    this.handleValidSubmit = this.handleValidSubmit.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { updateEntryStrategyError, loadingUpdateEntryStrategy, messageUpdateEntryStrategy } = this.props;

    // Escuchamos la respuesta de la petición de actualización
    if (loadingUpdateEntryStrategy === false && prevProps.loadingUpdateEntryStrategy === true) {
      if (updateEntryStrategyError) {
        this.setState({
          popup: true,
          pop_msg: 'Error al modificar la estrategia de entrada',
          alertType: 'error',
        });
      }
      if (messageUpdateEntryStrategy) {
        this.setState({
          popup: true,
          pop_msg: 'Estrategia de entrada modificada correctamente',
          alertType: 'correct',
        });
      }
    }
  }

  // Detectamos cambios en el input del nombre
  handleNameChange(event) {
    this.setState({ currentName: event.target.value });
  }

  confirmPopup() {
    this.setState({ popup: false });
    this.props.history.push('/entry-strategies');
  }

  handleValidSubmit = () => {
    const { user, entryStrategy, currentName } = this.state;

    // Llamamos a la acción usando la mejor práctica de desestructuración
    this.props.updateEntryStrategy({
      token: user.token,
      id: entryStrategy.id,
      name: currentName.trim(),
      history: this.props.history,
    });
  };

  render() {
    const { t } = this.props;
    const { entryStrategy, originalName, currentName, popup, alertType, pop_msg } = this.state;

    if (!entryStrategy) return null;

    // Validamos si el nombre fue alterado y no está vacío
    const isNameModified = currentName.trim() !== originalName.trim() && currentName.trim().length > 0;

    // El botón se activa sólo si hay cambios. Cambia su color según su estado activo
    const buttonColor = isNameModified ? 'secondary' : 'primary';

    return (
      <>
        <Col lg="12">
          <Card>
            <CardBody>
              <CardTitle className="mb-4">{t('UpdateEntryStrategy')}</CardTitle>
              <AvForm className="needs-validation" onValidSubmit={this.handleValidSubmit}>
                <Col>
                  <FormGroup>
                    <Label htmlFor="validationCustom01">{t('EntryStrategyName')}</Label>
                    <AvField
                      value={currentName}
                      name="name"
                      placeholder={t('EntryStrategyName')}
                      type="text"
                      errorMessage="Introduzca un nombre válido"
                      className="form-control"
                      onChange={this.handleNameChange} // Vinculamos el cambio
                      validate={{ required: { value: true } }}
                      id="validationCustom01"
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Button
                      color={buttonColor} // Dinámico: 'secondary' si cambia, 'primary' por defecto
                      type="submit"
                      disabled={!isNameModified} // Deshabilitado si no hay cambios reales
                      className="btn waves-effect waves-light buttonStatus mt-2"
                    >
                      {t('ModifyStrategyName')}
                    </Button>
                  </FormGroup>
                </Col>

                <EntryStrategyAreaList entryStrategyPositionList={entryStrategy.areas} strategyId={entryStrategy.id} />
              </AvForm>

              {popup && (
                <SweetAlert
                  type={alertType === 'correct' ? 'success' : 'error'}
                  title={pop_msg}
                  confirmBtnText={t('ok')}
                  onConfirm={() => this.confirmPopup()}
                />
              )}
            </CardBody>
          </Card>
        </Col>
      </>
    );
  }
}

const mapStateprops = (state) => {
  const { EntryStrategies } = state.getEntryStrategies;
  const { updateEntryStrategyError, loadingUpdateEntryStrategy, messageUpdateEntryStrategy, entryStrategyUpdated } =
    state.updateEntryStrategy;
  return {
    EntryStrategies,
    updateEntryStrategyError,
    loadingUpdateEntryStrategy,
    messageUpdateEntryStrategy,
    entryStrategyUpdated,
  };
};

export default withRouter(connect(mapStateprops, { updateEntryStrategy })(withNamespaces()(UpdateEntryStrategyForm)));
